import React from "react";
import { CardLayout } from "components/cardLayout";
import { companylogo } from "assets/images"
import "./CompanyDetailCard.scss"
import {getEstimatorDetails} from 'core/services/getEstimatorDetailsService'

export interface CompanyDetailCardProps {
    
}
 
export interface CompanyDetailCardState {
    companyDetails:any;
}
 
class CompanyDetailCard extends React.Component<CompanyDetailCardProps, CompanyDetailCardState> {
    private _isMounted: boolean = false;
    constructor(props: CompanyDetailCardProps) {
        super(props);
        this.state = { 
            companyDetails:[]
         };
    }

    async fetchData() {
        var CID = localStorage.getItem("CID")||"0";
        let response = await getEstimatorDetails(CID)
        this.setState({companyDetails:response[0]})
        console.log("CompDetail:"+JSON.stringify(this.state.companyDetails));
    }
    
    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() { 
        return ( 
            <CardLayout>
                <div className="company-logo">
                    <img src={companylogo} alt="" />
                </div>
                {/* <div className="company-detail">
                <h1>All My Sons Moving & Storage of Dallas, LLC.</h1>
                <p>2400 Old Mill Rd.</p>
                <p>Carrollton, TX 75007</p>
                <p className="agent-text">Origin Agent:</p>
                <p><span>All My Sons Moving & Storage of Dallas, LLC.</span></p>
                <p className="agent-text">Destination Agent:</p> 
                <p><span>All My Sons Moving & Storage of Dallas, LLC.</span></p> 
                </div> */}
                <div className="company-detail">
                    <p>Branch:</p>
                    {/* <h3><span>All My Sons Moving & Storage of Dallas, LLC.</span></h3> */}
                    <h3><span>{this.state.companyDetails.branchName}</span></h3>
                </div>
                <div className="company-detail">
                    <p>Address:</p>
                    {/* <h3>2400 Old Mill Rd. Carrollton, TX 75007</h3> */}
                    <h3>{this.state.companyDetails.branchAddress}</h3>
                </div>
                <div className="company-detail">
                    <p>Origin Agent:</p>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.origin}</h3>
                </div>
                <div className="company-detail">
                    <p>Destination Agent:</p>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.destination}</h3>
                </div>
            </CardLayout>
         );
    }
}
 
export default CompanyDetailCard;